import { Component, signal, output, input, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router'; 
import { SubProductForm } from './sub-product-form/sub-product-form';
import { SubProductsTable } from './sub-products-table/sub-products-table';
import {
  Attribute,
  CategoryLookup,
  SubProductTableItem,
} from '../../../../../pages/admin-dashboard/products/add-sub-product/sub-products.model';
import { SuccessfulNotification } from '../../../../../utils/successful-notification/successful-notification';

@Component({
  selector: 'app-sub-products-step',
  standalone: true,
  imports: [CommonModule, SubProductForm, SubProductsTable, SuccessfulNotification],
  templateUrl: './sub-products-step.html',
})
export class SubProductsStep implements OnInit {
  private router = inject(Router);

  productId = input.required<number>();
  attributes = input<Attribute[]>([]);
  categories = input<CategoryLookup[]>([]);
  parentTitleEn = input<string>('');
  parentTitleAr = input<string>('');

  onBack = output<void>();
  onFinalSave = output<void>();

  subProductsList = signal<SubProductTableItem[]>([]);
  showSubProductSuccess = signal(false);

  ngOnInit(): void {}

  onSubProductAdded(item: SubProductTableItem): void {
    this.subProductsList.update((list) => [...list, item]);

    this.showSubProductSuccess.set(true);

    setTimeout(() => {
      this.showSubProductSuccess.set(false);
    }, 2000);
  }

  handleFinalSave(): void {
    if (this.subProductsList().length > 0) {
      this.router.navigate(['/admin/products/view-product', this.productId()]);
    }
  }

  // removeFromTable(index: number): void {
  //   this.subProductsList.update(list => list.filter((_, i) => i !== index));
  // }
}
